import { Injectable } from '@angular/core';
import { catchError, Observable, of, throwError } from 'rxjs';
import { AutomaticParkingReportClient, AutomaticParkingReportParameterDTO, FilterDTO, PagedResultDTOOfAutomaticParkingReportDTO, SavedReportFileDTO, SortDirection } from 'src/app/base/models/models.swagger.generated';
import { ClientService } from 'src/app/base/services/client/client.service';
import { ToastService } from 'src/app/base/services/toast.service';
import { ShowInactiveService } from 'src/app/base/shared/grid-base/show-inactive.service';
import { IAdaptorService } from 'src/app/base/shared/syncfusion/adaptor-service.interface';
import { ErrorType } from 'src/app/core/routing/error-types';
import { SaveOptions } from '../../reports-footer/save-options';

@Injectable()
export class AutomaticParkingReportService extends ShowInactiveService implements IAdaptorService {
  public parameters: AutomaticParkingReportParameterDTO = new AutomaticParkingReportParameterDTO();

  constructor(private automaticParkingReportClient: AutomaticParkingReportClient,
              private toastService: ToastService,
              private clientService: ClientService) {
    super();
  }

  public getData(skip: number, take: number, filters: FilterDTO[], sortBy: string, sortDirection: SortDirection): Observable<PagedResultDTOOfAutomaticParkingReportDTO> {
    if (!this.parameters.dateRange.startDate || !this.parameters.dateRange.endDate) {
      return of(new PagedResultDTOOfAutomaticParkingReportDTO());
    }
    return this.automaticParkingReportClient.searchAutomaticParkingReportData(this.parameters, this.clientService.selectedClient?.id, skip, take, sortBy, sortDirection)
      .pipe(
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        }),
      );
  }

  public addRecord(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }

  public updateRecord(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }

  public deleteRecord(id: number): Observable<any> {
    throw new Error('Method not implemented.');
  }

  public exportReport(automaticParkingReportParameterDTO: AutomaticParkingReportParameterDTO, saveOptions: SaveOptions): Observable<SavedReportFileDTO> {
    return this.automaticParkingReportClient.exportAutomaticParkingReport(
      saveOptions.saveReport,
      automaticParkingReportParameterDTO,
      this.clientService.selectedClient?.id
    )
      .pipe(
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        }),
      );
  }

}
